//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatTime } from '../../components/helpers.js'
import { ACTIONS } from './ServiceObjectMaintenanceNote.js'
import ServiceObjectMaintenanceNoteOperation from './ServiceObjectMaintenanceNoteOperation.vue'
import ReadonlyDocumentsField from '../../components/File/ReadonlyDocumentsField.vue'
import Table from '../../components/Table/Table.vue'

export default {
  components: {
    ReadonlyDocumentsField,
    Table
  },
  props: {
    operations: {
      type: Array,
      default: function () {
        return []
      }
    },
    recordId: {
      type: Number,
      default: null
    },
    access: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      formatTime: formatTime,
      componentKey: 0,
      opened: false,
      columns: [
        {
          name: 'time',
          label: 'Дата/время добавления операции',
          align: 'left',
          field: 'time',
          sortable: false,
          format: formatTime,
          hideMobile: true
        },
        {
          name: 'operationTime',
          label: 'Дата/время выполнения операции',
          align: 'left',
          field: 'operationTime',
          sortable: false,
          format: formatTime,
          hideMobile: true
        },
        {
          name: 'shortFio',
          label: 'Пользователь, выполнивший операцию',
          align: 'left',
          field: 'shortFio',
          sortable: false,
          hideMobile: true
        },
        {
          name: 'comment',
          label: 'Комментарий',
          align: 'left',
          field: 'comment',
          sortable: false,
          defaultWidth: 400,
          style: 'white-space: pre-line !important; word-break: break-all;'
        },
        {
          name: 'commentType',
          label: 'Тип записи',
          align: 'left',
          field: 'commentType',
          sortable: false,
          format: n => n ? n.name : null
        },
        {
          name: 'noteStatus',
          label: 'Статус',
          align: 'left',
          field: 'noteStatus',
          sortable: false,
          format: n => n ? n.name : null
        },
        {
          name: 'files',
          label: 'Фотографии',
          align: 'left',
          field: 'files',
          sortable: false
        },
        {
          name: 'recordSource',
          label: 'Тип источника записи',
          align: 'left',
          field: 'recordSource',
          sortable: false,
          format: r => r ? r.name : null,
          hideMobile: true
        },
        {
          name: 'sourceObject',
          label: 'Источник записи',
          align: 'left',
          field: 'sourceObject',
          sortable: false,
          hideMobile: true
        }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 0 // все строки
      }
    }
  },
  computed: {
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    }
  },
  watch: {
    operations: {
      handler: function () {
        for (let i = 0; i < this.operations.length; i++) {
          if (this.operations[i].fileIds) {
            this.$set(this.operations[i], 'files', [])

            for (let j = 0; j < this.operations[i].fileIds.length; j++) {
              const fileId = this.operations[i].fileIds[j]
              this.operations[i].files.push({
                name: 'Замечание к объекту' + '-' + fileId,
                id: fileId
              })
            }
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    showColumnMobile: function (col) {
      const val = col.value
      const hasColumnValue = val != null && !!val && val.length > 0 && val !== 'Нет'
      return !col.hideMobile && hasColumnValue
    },
    onAction: function (operation, action) {
      this.$d.dialog(this).show({
        maximized: false,
        persistent: true,
        headerHidden: true,
        contentComponent: ServiceObjectMaintenanceNoteOperation,
        contentProps: {
          recordId: this.recordId,
          inputOperation: operation,
          action: action,
          dialog: true
        },
        componentHandlers: {
          cancel: () => {
            this.closedOperation()
          },
          update: () => {
            this.$emit('update')
          }
        }
      })
    },
    onEdit: function (operation) {
      const action = ACTIONS.find(action => action.key === 'edit')
      this.onAction(operation, action)
    },
    onDelete: function (operation) {
      const action = ACTIONS.find(action => action.key === 'delete')
      this.onAction(operation, action)
    },
    closedOperation: function (operation) {
      this.opened = false
      this.editedOperation = null
      this.action = null
      this.componentKey++
    }
  }
}

